// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { MasterEffects } from './store/effects';
import * as fromMaster from './store/reducer';

// SERVICES
import { MasterStoreService } from './master-store.service';
import { MasterService } from './services/master.service';

/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['countryLookUp', 'timezoneLookUp','trainingLicenseLookUp'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure master ngrx related stuff.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) configure master store ng module
 */
@NgModule({
  imports: [
    StoreModule.forFeature('master', fromMaster.reducer, { metaReducers }),
    EffectsModule.forFeature([MasterEffects]),
  ],
  declarations: [],
  providers: [
    MasterService,
    MasterStoreService,
  ],
})
export class MasterStoreModule { }
